import { useState } from "react";
import { Box, Button, useToast, VStack } from "@chakra-ui/react";
import { useAddFiatAccountMutation } from "apis";
import { InputLabel, Input, Select } from "components";

interface IProps {
  handleTabChange: (index: number) => void;
}
const AddAccount = ({ handleTabChange }: IProps) => {
  const toast = useToast();
  const [state, setState] = useState({
    institutionName: "gtb",
    accountNumber: "",
    accountName: "",
    country: "ng",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const [_addAccount, { isLoading }] = useAddFiatAccountMutation();

  const handleAddAccount = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { accountName, accountNumber, institutionName, country } = state;

    try {
      const response = await _addAccount({
        accountName,
        accountNumber,
        institutionName,
        country,
      }).unwrap();

      console.log(response, "RESPOSNE");
      if (response) {
        handleTabChange(1);

        toast({
          position: "bottom-right",
          title: "Success",
          description: "Bank account added sucessfull",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error: any) {}
  };

  return (
    <Box mt="16px">
      <form onSubmit={handleAddAccount}>
        <VStack spacing="24px">
          <Box width="100%">
            <InputLabel htmlFor="country">Country</InputLabel>
            <Select id="country" name="country" onChange={handleChange}>
              <option value="ng">Nigeria</option>
              <option value="ke">Kenya</option>
              <option value="gh">Ghana</option>
            </Select>
          </Box>

          <Box width="100%">
            <InputLabel htmlFor="institutionName">Bank Name</InputLabel>
            <Select id="institutionName" name="institutionName" onChange={handleChange}>
              <option value="gtb">GTB</option>
              <option value="uba">UBA</option>
              <option value="zenith">Zenith</option>
            </Select>
          </Box>

          <Box width="100%">
            <InputLabel htmlFor="accountNumber">Account Number</InputLabel>
            <Input
              onChange={handleChange}
              isRequired
              type="number"
              id="accountNumber"
              name="accountNumber"
              placeholder="Account Number"
            />
          </Box>

          <Box width="100%">
            <InputLabel htmlFor="accountName">Account Name</InputLabel>
            <Input onChange={handleChange} isRequired id="accountName" name="accountName" placeholder="Account Name" />
          </Box>
        </VStack>

        <Button mt="42px" width="100%" type="submit" isLoading={isLoading} minW={{ base: "auto", "2sm": "400px" }}>
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default AddAccount;
